
/*
 * Copyright (C) 2015 ICOS Group, Newcastle University.  All rights reserved.
 * Contact:  James Alastair McLaughlin <j.a.mclaughlin@ncl.ac.uk>
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *  
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND CONTRIBUTORS ``AS IS'' AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
 * OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
 * HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
 * SUCH DAMAGE.
 */

"use strict";

var xml = require('xml'),
    serializeIdentified = require('./serializeIdentified'),
    serializeMapping = require('./serializeMapping');

module.exports = function serializeVariableComponent(sbolDocument, xmlAttribsRef, component) {

    var properties = [
        { 'sbol:variable': { _attr: { 'rdf:resource': component.variable.uri?component.variable.uri:component.variable }}},
        { 'sbol:operator': { _attr: { 'rdf:resource': component.operator }}},
    ]

    component.variants.forEach(function(variant) {
        properties.push({ 'sbol:variant': { _attr: { 'rdf:resource': variant.uri ? variant.uri : variant }}});
    });

    component.variantCollections.forEach(function(variantCollection) {
        properties.push({ 'sbol:variantCollection': { _attr: { 'rdf:resource': variantCollection.uri ? variantCollection.uri : variantCollection }}});
    });

    component.variantDerivations.forEach(function(variantDerivation) {
        properties.push({ 'sbol:variantDerivation': { _attr: { 'rdf:resource': variantDerivation.uri ? variantDerivation.uri : variantDerivation }}});
    });

    return serializeIdentified(sbolDocument, xmlAttribsRef, component, 'sbol:VariableComponent', properties);

}

